import { useEffect, useRef } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { tooltipContainerState, TooltipContainer } from "../../recoil/tooltip/atom";
import { useAgreementCheckInit } from "src/pages/join/hooks/useAgreementCheckInit";
import { useAnonymousPathPatterns } from "src/pages/hooks/anonymous-path-patterns";
import { useMemberInfoState } from "src/recoil/member/hook";
import { scrollState } from "src/recoil/scroll/atom";
import RoutesList from "src/routes/RoutesList";
import ErrorModal from "../ErrorModal";
import RefreshTokenErrorModal from "../RefreshTokenErrorModal";
import ToastList from "../ToastList";
import UpdateBanner from "../UpdateBanner";
import BreadCrumbs from "./BreadCrumbs";
import FooterPC from "./FooterPC";
import HeaderPC from "./HeaderPC";
import ScrollToTop from "./ScrollToTop";


/**
 * App > Container > Layout
 */
function Layout() {
  const scrollTopRef = useRef<any>(null);
  const scrollRef = useRef<any>(null);
  const baseLayoutContentsRef = useRef<HTMLDivElement>(null);
  const setTooltipContainer = useSetRecoilState<TooltipContainer>(tooltipContainerState);
  const { fetchMemberMe } = useMemberInfoState();
  const [scroll, setScroll] = useRecoilState(scrollState);
  // 무인증 페이지 여부
  const { matchAnonymous } = useAnonymousPathPatterns();
  // 로드당 1회 미동의 약관 재검증
  useAgreementCheckInit();

  useEffect(() => {
    // css property 사용하여 ios 모바일에서 스크롤 생기는 문제 해결
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
    if (window.ReactNativeWebView) {
      document.body.classList.add("open-taap");
    }
  });

  useEffect(() => {
    if (baseLayoutContentsRef.current) {
      setTooltipContainer({ element: baseLayoutContentsRef.current });
    }
  }, [setTooltipContainer]);

  useEffect(() => {
    // 로그인한 사용자 정보 조회
    // if (!matchAnonymous) {
    fetchMemberMe();
    // }
  }, [matchAnonymous, fetchMemberMe]);

  // useEffect(() => {
  //   // 스크롤위치 저장
  //   scrollRef.current.addEventListener("scroll", () => {
  //     setScroll(scrollRef.current.scrollTop);
  //   });
  //   return () => {
  //     scrollRef.current.removeEventListener("scroll", () => {
  //       setScroll(scrollRef.current.scrollTop);
  //     });
  //   };
  // }, []);

  return (
    <>
      <ScrollToTop containerRef={scrollTopRef} />
      <div className="base-layout-wrap">
        <main className={`base-layout-container`} ref={scrollRef}>
          <div ref={scrollTopRef}></div>
          <BreadCrumbs />
          <div className="base-layout">
            <div className="base-layout-contents" ref={baseLayoutContentsRef}>
              <RoutesList />
            </div>
          </div>
        </main>
      </div>
      <ToastList />
      <UpdateBanner />
      <RefreshTokenErrorModal />
      <ErrorModal />
    </>
  );
}

export default Layout;
